module.exports = __webpack_public_path__ + "static/media/close_game.22452e75.mp3";